import { type MicroAgent } from '@newrelic/browser-agent/loaders/micro-agent'
import { FragmentLogger, LogLevel, convertLogLevel } from '../fragment-logger'
import { type Logger as LogLevelLogger } from 'loglevel'

export class MicroAgentLogger extends FragmentLogger {
  protected agent?: MicroAgent
  private readonly microAgentLogLevel: LogLevel

  constructor (logger: LogLevelLogger, agent: MicroAgent, microAgentLogLevel?: string | number) {
    super(logger)
    this.agent = agent
    this.microAgentLogLevel = convertLogLevel(microAgentLogLevel ?? 'error')
  }

  override postLog (level: LogLevel, message: any, ...params: any[]): void {
    if (level < this.microAgentLogLevel) return

    this.agent?.noticeError(message, { level: LogLevel[level], params })
  }
}
